import React, { useCallback, useEffect, useState } from "react"
import DataTable from "react-data-table-component"
import { Navigate } from "react-router-dom"
import { FaRotate } from "react-icons/fa6"
import * as moment from "moment"
import { GetWinningPerAgent } from "../../services/AcceptedBetsServices"
import { getCookie } from "../../utils/cookies"
import "../../css/WinningBets.css"

const WinningBets = () => {
  const user = getCookie("usercode")
  const todayDate = moment().format("yyyy-MM-DD")
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const peso = (value) => `₱${Number(value || 0).toFixed(2)}`

  const columns = [
    {
      name: "Draw",
      selector: (row) => <span className="winning-draw">{row.drawtime || "—"}</span>,
      grow: 0.8,
    },
    {
      name: "Combination",
      selector: (row) => <span className="winning-combination">{row.combination || "—"}</span>,
      grow: 1.2,
    },
    {
      name: "Amount",
      selector: (row) => <span className="winning-money">{peso(row.betamount)}</span>,
      right: true,
    },
    {
      name: "Prize",
      selector: (row) => <span className="winning-prize">{peso(row.winningprize)}</span>,
      right: true,
    },
  ]

  const tableStyles = {
    headCells: { style: { paddingLeft: "8px", paddingRight: "8px" } },
    cells: { style: { paddingLeft: "8px", paddingRight: "8px" } },
    rows: { style: { cursor: "default" } },
    pagination: { style: { borderTop: "1px solid #f0f1f4" } },
  }

  const LoadWinning = useCallback(async () => {
    try {
      setIsLoading(true)
      const result = await GetWinningPerAgent({ date: todayDate, usercode: user })
      setData(Array.isArray(result) ? result : [])
    } catch (error) {
      console.log(error)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }, [todayDate, user])

  useEffect(() => {
    LoadWinning()
  }, [LoadWinning])

  if (!user) return <Navigate to="/" replace />

  const totalPrize = data.reduce((total, row) => total + Number(row.winningprize || 0), 0)

  return (
    <main className="winning-page">
      <div className="winning-shell">
        <header className="winning-header">
          <div>
            <span className="winning-eyebrow">Today&apos;s results</span>
            <h1>Winning bets</h1>
          </div>
          <span className="winning-agent">{user}</span>
        </header>

        <section className="winning-card winning-summary">
          <div>
            <span className="winning-summary-label">Total prize</span>
            <strong className="winning-total">₱{totalPrize.toFixed(2)}</strong>
          </div>
          <div className="winning-summary-side">
            <span>{todayDate}</span>
            <small>{data.length} {data.length === 1 ? "winning bet" : "winning bets"}</small>
          </div>
        </section>

        <section className="winning-card winning-list-card">
          <div className="winning-list-heading">
            <div>
              <h2>Winning bets</h2>
              <span>Results for today</span>
            </div>
            <button
              type="button"
              className="winning-refresh"
              aria-label="Refresh winning bets"
              onClick={LoadWinning}
              disabled={isLoading}
            >
              <FaRotate className={isLoading ? "winning-spin" : ""} />
            </button>
          </div>
          <div className="winning-table-wrap">
            <DataTable
              columns={columns}
              data={data}
              fixedHeader
              fixedHeaderScrollHeight="calc(100% - 42px)"
              pagination
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5]}
              progressPending={isLoading}
              customStyles={tableStyles}
              noDataComponent={
                <div className="winning-empty">
                  <strong>No winning bets yet</strong>
                  Winning results will appear here when available.
                </div>
              }
            />
          </div>
        </section>
      </div>
    </main>
  )
}

export default WinningBets
